import React from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import TagsBox from './TagsBox';

class Tags extends React.Component {
    state = { LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}] }

    componentDidMount(){
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //fetch('https://api.ipify.org/?format=json')
        fetch('https://geolocation-db.com/json/')
            .then(response => {
                return response.json();
            }, "jsonp")
            .then(res => {
                this.setLog('pages/log/Tags/visit/'+res.IPv4.replaceAll('.',','))
            })
            .catch(err => this.setLog('pages/log/Tags/visit/'+err));
    }

    async setLog(Data) {
        await webapi.post(Data);
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }

    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/203/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/203/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }
    }

    render() {
        if (this.state.pageData && this.state.LanguageInfo) {
            return (
                <div>
                    <Header LanguageInfo = {this.state.LanguageInfo}/>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                            <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F203!== undefined?this.state.pageData[0].F203:203/*جستجوی برچسب دستوری*/}</h1>
                            <h2 id="page_title_dek">{this.state.pageData.length!==0 && this.state.pageData[0].F20300!== undefined?this.state.pageData[0].F20300:20300/*مقوله دستوری واژه‌های فارسی میانه*/}</h2>
                            <hr className="halfwidth" />
                        </div>
                    </div>
                    <TagsBox    pageData={this.state.pageData}
                                Lang = {this.state.LanguageInfo[0].Code}
                    />
                    <Footer Lang = {this.state.LanguageInfo[0].Code}/>
                </div>
            )
        }
        else
        {
            return (
                <div></div>
            )
        }
    }
 }

 export default Tags;

